// extracted by mini-css-extract-plugin
module.exports = {"edit-menu-wrapper":"editor_common_edit-menu-wrapper__36rVg"};